import { AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import { fetchListOfStructures } from "src/Pages/Company/OrganizationStructure/api";
import { IStructureData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/Forms/OrganizationStructureForm.models";
import { retryQueryConfig } from "src/Pages/Company/OrganizationStructure/config/retryQueryConfig";

const useFetchListOfStructures = (
  companyId: string,
  shouldFetch: boolean = true
) =>
  useQuery<IStructureData[], AxiosError>({
    enabled: !!companyId && shouldFetch,
    queryKey: ["list-of-structures", { companyId }],
    queryFn: async ({ signal }) => {
      const { data } = await fetchListOfStructures(companyId, { signal });
      return data;
    },
    ...retryQueryConfig,
  });

export default useFetchListOfStructures;
